import { avgReviewFilter } from '../constants/productGrid';

import { addCustomFilterSettings } from './addCustomFilterSettings';

export const addAvgReviewFilterSetting = addCustomFilterSettings(
  'review',
  avgReviewFilter
);
